(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.visible = false;
      this.priceEl = this.querySelector('[data-satc-price]');
      this.priceLabelEl = this.querySelector('[data-satc-price-label]');
      this.modeButtons = Array.from(this.querySelectorAll('[data-satc-mode]'));
      this.ctaEl = this.querySelector('[data-satc-cta]');

      customElements.whenDefined('subscription-card').then(() => {
        this.card = document.querySelector('subscription-card');
        if (!this.card) return;
        this.bindCard();
      });
    }

    disconnectedCallback() {
      if (this.checkBound) {
        window.removeEventListener('scroll', this.checkBound);
        window.removeEventListener('resize', this.checkBound);
      }
    }

    bindCard() {
      this.modeButtons.forEach((btn) =>
        btn.addEventListener('click', () => this.card.setMode(btn.dataset.satcMode))
      );
      this.ctaEl.addEventListener('click', () => this.addToCart());
      document.addEventListener('subscription:change', (e) => this.sync(e.detail));

      this.checkBound = this.check.bind(this);
      window.addEventListener('scroll', this.checkBound, { passive: true });
      window.addEventListener('resize', this.checkBound);
      this.check();

      this.sync({ mode: this.card.mode, total: this.card.totalPrice() });
    }

    check() {
      if (this.checkScheduled) return;
      this.checkScheduled = true;
      window.requestAnimationFrame(() => {
        this.checkScheduled = false;
        const rect = this.card.getBoundingClientRect();
        this.toggleVisibility(rect.bottom < 80);
      });
    }

    toggleVisibility(show) {
      if (show === this.visible) return;
      this.visible = show;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        this.removeAttribute('inert');
      } else {
        this.setAttribute('inert', '');
      }
    }

    money(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    sync(detail) {
      if (!detail) return;
      const isSub = detail.mode === 'sub';

      this.modeButtons.forEach((btn) => {
        const active = btn.dataset.satcMode === detail.mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (this.priceEl) this.priceEl.textContent = this.money(detail.total);
      if (this.priceLabelEl) {
        if (isSub) {
          const discount = parseInt(this.card.dataset.subDiscount, 10) || 0;
          this.priceLabelEl.textContent = discount > 0 ? '/mês · −' + discount + '%' : '/mês';
        } else {
          this.priceLabelEl.textContent = 'à vista';
        }
      }
    }

    addToCart() {
      if (!this.card.form) return;
      this.ctaEl.setAttribute('aria-disabled', 'true');
      if (typeof this.card.form.requestSubmit === 'function') {
        this.card.form.requestSubmit();
      } else {
        this.card.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      window.setTimeout(() => this.ctaEl.removeAttribute('aria-disabled'), 1500);
    }
  }

  customElements.define('sticky-atc', StickyAtc);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_subscription"] && !Shopify.designMode) return;
  try {
    class TpSubscriptionCard extends HTMLElement {
    constructor() {
      super();
      this.base = parseInt(this.dataset.base, 10) || 0;
      this.subPrice = parseInt(this.dataset.subPrice, 10) || this.base;
      this.oncePrice = parseInt(this.dataset.oncePrice, 10) || this.base;
      this.subVariant = this.dataset.variantSub;
      this.onceVariant = this.dataset.variantOnce;
      this.mode = 'sub';
      this.qty = 1;

      this.form = this.querySelector('form');
      this.quantityInput = this.querySelector('[data-quantity-input]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.qtyDisplay = this.querySelector('[data-qty-display]');
      this.ctaText = this.querySelector('[data-cta-text]');
      this.ctaPrice = this.querySelector('[data-cta-price]');
      this.cta = this.querySelector('[data-cta]');
      this.tiersEl = this.querySelector('[data-tiers]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      this.modes = Array.from(this.querySelectorAll('[data-mode]'));
    }

    connectedCallback() {
      this.modes.forEach((btn) =>
        btn.addEventListener('click', () => this.setMode(btn.dataset.mode))
      );
      this.tiers.forEach((btn) =>
        btn.addEventListener('click', () => this.setQty(parseInt(btn.dataset.tierQty, 10)))
      );
      this.querySelectorAll('[data-qty-step]').forEach((btn) =>
        btn.addEventListener('click', () => this.setQty(this.qty + parseInt(btn.dataset.qtyStep, 10)))
      );
      // O submit do formulario e tratado pelo <product-form> do tema (add ao carrinho + cart drawer).
      this.render();
    }

    money(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    tierForQty(q) {
      return this.tiers.find((t) => parseInt(t.dataset.tierQty, 10) === q) || null;
    }

    totalPrice() {
      const unit = this.mode === 'sub' ? this.subPrice : this.oncePrice;
      const tier = this.tierForQty(this.qty);
      const disc = tier ? parseInt(tier.dataset.tierDiscount, 10) : 0;
      return Math.round((unit * this.qty * (100 - disc)) / 100);
    }

    setMode(mode) {
      this.mode = mode;
      this.modes.forEach((btn) => {
        const active = btn.dataset.mode === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      this.render();
    }

    setQty(q) {
      this.qty = Math.max(1, Math.min(9, q));
      this.render();
    }

    render() {
      if (this.qtyDisplay) this.qtyDisplay.textContent = this.qty;
      if (this.quantityInput) this.quantityInput.value = this.qty;

      const isSub = this.mode === 'sub';
      if (this.variantInput) this.variantInput.value = isSub ? this.subVariant : this.onceVariant;

      const unit = isSub ? this.subPrice : this.oncePrice;
      const economize = this.dataset.economize || 'economize';
      this.tiers.forEach((t) => {
        const tQty = parseInt(t.dataset.tierQty, 10);
        const tDisc = parseInt(t.dataset.tierDiscount, 10) || 0;
        const price = Math.round((unit * tQty * (100 - tDisc)) / 100);
        const save = unit * tQty - price;
        const priceEl = t.querySelector('[data-tier-price]');
        const saveEl = t.querySelector('[data-tier-save]');
        if (priceEl) priceEl.textContent = this.money(price);
        if (saveEl) saveEl.innerHTML = save > 0 ? economize + ' ' + this.money(save) : '&nbsp;';

        const active = tQty === this.qty;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (this.ctaText) {
        this.ctaText.textContent = isSub
          ? this.dataset.ctaSub || this.ctaText.textContent
          : this.dataset.ctaOnce || this.ctaText.textContent;
      }
      if (this.ctaPrice) this.ctaPrice.textContent = this.money(this.totalPrice());

      this.dispatchEvent(
        new CustomEvent('subscription:change', {
          bubbles: true,
          detail: { mode: this.mode, qty: this.qty, total: this.totalPrice() },
        })
      );
    }

  }

  customElements.define('subscription-card', TpSubscriptionCard);
  } catch(e) { console.error(e); }
})();

})();
